import React from "react";
import { Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { loggedIn } from "../../helpers/LocalStorageHelper";
import store from "../../Store";
import AdminRoutes from "./../AdminRoutes";
import NotFound from "../../pages/NotFound";
import LoginRoutes from "../LoginRoutes";
import {
  endOfURL,
  atHomePage,
  startOfURL,
  secondToLastItemInURL,
} from "../../helpers/UrlHelper";
import Sidebar from "../../components/layout/Sidebar";
import { setUser } from "./MainRoute-Actions";
import getLoggedInUser from "../../ajax/actions/user/user_loggedin_get";
import OrganizationAdminRoutes from "../OrganizationAdminRoutes";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import TwoFactorAuthCheck from "../../../src/components/shared/pages/2FA_Redirect";
import CelestioLogo from "../../components/shared/branding/CelestioLogo";

class MainRoute extends React.Component {
  componentDidMount() {
    this.syncOrganizationDashboardClass();

    if (endOfURL() === "analytics" || endOfURL() === "requested") {
      document.body.classList.add("developing");
    } else {
      document.body.classList.remove("developing");
    }

    if (loggedIn()) {
      store.dispatch(getLoggedInUser());
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("organization-dashboard");
  }

  removeClassDeveloping() {
    document.body.classList.remove("developing");
  }

  // Every dashboard page (except the org-admin's own "/dashboard" home,
  // which renders without a Sidebar) needs `organization-dashboard` on
  // <body> for the sidebar/topbar/content-area shell CSS to line up.
  // Applying it here — synchronously on mount/update — means it's set
  // before the first paint, instead of waiting on individual page
  // components to add it in their own componentDidMount once the async
  // getLoggedInUser() role fetch resolves, which caused a visible
  // "sidebar starts wide, then snaps to size" flash on every page load.
  syncOrganizationDashboardClass() {
    if (loggedIn() && startOfURL() !== "dashboard") {
      document.body.classList.add("organization-dashboard");
    } else {
      document.body.classList.remove("organization-dashboard");
    }
  }

  componentDidUpdate(prev) {
    this.syncOrganizationDashboardClass();

    if (endOfURL() !== "requested" && endOfURL() !== "analytics") {
      this.removeClassDeveloping();
    }

    if (this.props.getLoggedInUser !== prev.getLoggedInUser) {
      let { success } = this.props.getLoggedInUser;
      if (success) {
        store.dispatch(setUser(success.data.data));
      }
    }
  }

  render() {
    let { action, role, user, getLoggedInUser } = this.props;
    const initials = user && user.first_name;

    // While a token is present but we haven't yet resolved the logged-in
    // user's role, show a full-page loader instead of the dashboard shell
    // (or the blank content-area that would otherwise flash before `role`
    // is populated). A non-401 fetch error falls through to the shell
    // below rather than getting stuck here, since 401s already trigger a
    // hard redirect to /login via `logOut()`.
    if (loggedIn() && !role && !getLoggedInUser.error) {
      return (
        <div className="full-page-loader">
          <div className="full-page-loader__brand">
            <CelestioLogo size={40} large variant="dark" />
          </div>
          <div className="full-page-loader__status">
            <span className="full-page-loader__spinner" />
            Signing you in...
          </div>
        </div>
      );
    }

    if (action === "render-404") {
      return <NotFound />;
    } else {
      return loggedIn() ? (
        <>
          {/*<TwoFactorAuthCheck/>*/}
          <HeaderNavigation
            url={endOfURL()}
            startOfURL={startOfURL()}
            role={role}
          />
          <section className="Main-App">
            <div className="container-fluid p-0">
              <div className="row no-gutters">
                {startOfURL() !== "dashboard" && (
                  <div className="col sidebar-wrapper">
                    <Sidebar
                      url={endOfURL()}
                      startOfURL={startOfURL()}
                      secondToLastItemInURL={secondToLastItemInURL()}
                      home={atHomePage()}
                    />
                  </div>
                )}
                <div
                  className={
                    atHomePage()
                      ? "col content-area-wrapper pb-0"
                      : "col content-area-wrapper"
                  }
                  id={
                    endOfURL() === "statistics" && "statistics-content-wrapper"
                  }
                >
                  <div className="content-area">
                    {role && role === "organization-admin" && (
                      <Route path="/" component={OrganizationAdminRoutes} />
                    )}
                    {role && role === "super-admin" && (
                      <Route path="/" component={AdminRoutes} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="Download-App">
            <div className="under-development col-md-8 col-sm-8 col-xs-8">
              <h3>
                Hi <span>{initials}</span>,
              </h3>
              <h3>We are currently developing</h3>
              <h3 className="spacing">Our mobile HQ platform.</h3>
              <p>
                For now our platform is only optimised for smaller MacBooks and
                devices. For iPad & Mobile please download our internal apps to
                administrate the Celestio infrastructure. Please note that some
                settings are only available from the desktop version.
              </p>
            </div>
          </section>
        </>
      ) : (
        <LoginRoutes />
      );
    }
  }
}

function mapStateToProps(state) {
  let { route, loginForm, getLoggedInUser } = state;
  let { action, routes_url, user } = route.data;
  let role = route && route.data.user && route.data.user.role.slug;
  let { redirectTo } = loginForm.data;
  return {
    route,
    action,
    loginForm,
    redirectTo,
    routes_url,
    getLoggedInUser,
    role,
    user,
  };
}

export default withRouter(connect(mapStateToProps)(MainRoute));
